import { roundRect, triangleObject, circleObject } from "../utils/utils";
import { FabricPlugin } from "./FabricPlugin";

/**
 * Plugin used for some plugins to draw folded shape
 */
export class FoldedCornerPlugin extends FabricPlugin {
    style;

    radius = 5;

    constructor(options, ctx, style, data) {
        super(options, ctx, data);
        this.style = style;
    }

    drawFolded() {
        this.ctx.fillStyle = this.style.fill;
        const pos = super.getPosition(); const
            size = super.getSize();
        const { x } = pos;
        const { y } = pos;
        const width = size.customWidth || size.width;
        const height = size.customHeight || size.height;
        const style = { fillStyle: this.style.fill };
        const triangleStyle = { fillStyle: this.style.fillFirstTriangle, strokeStyle: this.style.stroke };
        const topRightTriangleStyle = { fillStyle: this.style.fillSecondTriangle };
        if (this.size.backgroundRadius) {
            const xCenter = this.position.x + this.size.width / 2;
            const yCenter = this.position.y + (this.size.height / 2);
            const customX = x + this.size.backgroundRadius;
            const customY = y + this.size.backgroundRadius;
            circleObject(xCenter, yCenter, this.size.customRadiusMax + this.size.backgroundRadius, {
                fillStyle: this.size.backgroundColor
            }, this.ctx);
            roundRect(customX, customY, width, height, this.radius, style, this.ctx);
            triangleObject(customX, customY, width, height, this.radius, triangleStyle, this.ctx);
            triangleObject(customX, customY, width, height, this.radius, topRightTriangleStyle, this.ctx, "rightTop");
        } else {
            roundRect(x, y, width, height, this.radius, style, this.ctx);
            triangleObject(x, y, width, height, this.radius, triangleStyle, this.ctx);
            triangleObject(x, y, width, height, this.radius, topRightTriangleStyle, this.ctx, "rightTop");
        }
        this.fabricPluginRedrawed();
    }

    updateFoldedPlugin(options) {
        this.setPosition(options && options.position ? options.position : super.getPosition());
        this.setSize(options && options.size ? options.size : super.getSize());
    }
}
